import { anyWindow } from "./global";

export const env = {
    isWebKit:
        typeof document !== "undefined" &&
        "WebkitAppearance" in document.documentElement.style,

    supportsTouch:
        typeof window !== "undefined" &&
        ("ontouchstart" in window ||
            ("maxTouchPoints" in window.navigator &&
                window.navigator.maxTouchPoints > 0) ||
            (anyWindow.DocumentTouch &&
                document instanceof anyWindow.DocumentTouch)),

    supportsIePointer:
        typeof navigator !== "undefined" && (navigator as any).msMaxTouchPoints,

    isChrome:
        typeof navigator !== "undefined" &&
        /Chrome/i.test(navigator && navigator.userAgent),
};
